import { render, staticRenderFns } from "./CustomerAccounts.vue?vue&type=template&id=d86a8cbc&scoped=true&"
import script from "./CustomerAccounts.vue?vue&type=script&lang=js&"
export * from "./CustomerAccounts.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAccounts.vue?vue&type=style&index=0&id=d86a8cbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86a8cbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d86a8cbc')) {
      api.createRecord('d86a8cbc', component.options)
    } else {
      api.reload('d86a8cbc', component.options)
    }
    module.hot.accept("./CustomerAccounts.vue?vue&type=template&id=d86a8cbc&scoped=true&", function () {
      api.rerender('d86a8cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/CustomerAccounts.vue"
export default component.exports